export default __webpack_public_path__ + "static/LogoOG-a3f5c7691eb0ea116ca209e4711862e9.png";